import { QueovalBase, QueovalDate} from '../global/class.global';
import { Select } from '../utilities';
export class ExportEcrituresModel extends QueovalBase {
  public lstFilesGenerated: Array<FileGenerated>;
  public lstFormats: Array<Select>;
  public lstFilesToDelete: Array<string>;
  public lstCodeJournal: Array<Select>;
  public lstRelationEntiteCodeJournal: Array<Select>;
  public lstNumeroEcriture: Array<Select>;

  public format: string;
  public regrouperBQ: boolean;
  public detailler: boolean;
  public strIdEntite: string;
  public strCodeJournal: string;
  public strModeExportIBIZAauto: string;
  public boolWithPdfFile: boolean;
  public dtDebut: QueovalDate;
  public dtFin: QueovalDate;
  public strNumeroEcriture: string;
  public boolWithInfoReglement: boolean;
  public exportAsync: boolean;

  constructor() {
    super();
    this.lstFilesGenerated = new Array<FileGenerated>();
    this.lstFormats = new Array<Select>();
    this.lstCodeJournal = new Array<Select>();
    this.lstFilesToDelete = new Array<string>();
    this.lstNumeroEcriture = new Array<Select>();

    this.strNumeroEcriture = 'ALL';
    this.regrouperBQ = false;
    this.detailler = false;
    this.boolWithInfoReglement = true;
    this.strModeExportIBIZAauto = 'MODE_NORMAL';
    this.exportAsync = false;
    this.boolWithPdfFile = true;
    this.dtDebut = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), '1');
    this.dtFin = new QueovalDate(new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString(), new Date().getDate().toString());
  }
}
export class FileGenerated {
  public checked: boolean;
  public name: string;
  public strDate: string;
  public file: string;
  constructor() {
    this.checked = false;
    this.name = '';
    this.strDate = '';
    this.file = '';
  }
}

